import { render, staticRenderFns } from "./67.vue?vue&type=template&id=0d239878&scoped=true&"
import script from "./67.vue?vue&type=script&lang=js&"
export * from "./67.vue?vue&type=script&lang=js&"
import style0 from "./67.vue?vue&type=style&index=0&id=0d239878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d239878",
  null
  
)

export default component.exports